import { FabricObject } from "fabric"

let configured = false

/**
 * Fabric 7 changed the default object origin from left/top to center/center.
 * DTMS coordinates and the existing canvas tools are persisted as left/top,
 * so keep that contract at the application boundary during the v7 migration.
 */
export function configureFabricCompatibility() {
    if (configured) return

    FabricObject.ownDefaults.originX = "left"
    FabricObject.ownDefaults.originY = "top"
    configured = true
}

